import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  IconButton,
  Typography
} from '@mui/material';
import { Edit, Delete } from '@mui/icons-material';

const TriggerList = ({ triggers, onEdit, onDelete }) => {
  const list = triggers || [];

  return (
    <TableContainer component={Paper} variant="outlined" sx={{ overflowX: 'auto' }}>
      <Table size="small" stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell>Name</TableCell>
            <TableCell>Key</TableCell>
            <TableCell>Description</TableCell>
            <TableCell>Created</TableCell>
            <TableCell align="right" sx={{ whiteSpace: 'nowrap', minWidth: 112 }}>
              Actions
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {list.length === 0 ? (
            <TableRow>
              <TableCell colSpan={5} align="center">
                <Typography variant="body2" color="text.secondary">
                  No triggers yet. Create a trigger to get started.
                </Typography>
              </TableCell>
            </TableRow>
          ) : (
          list.map((trigger) => (
            <TableRow key={trigger._id} hover>
              <TableCell>
                <Typography variant="body1" fontWeight="medium">
                  {trigger.name}
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="body2" color="primary" fontFamily="monospace">
                  {trigger.key}
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="body2" color="textSecondary">
                  {trigger.description || 'No description'}
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="body2" color="textSecondary">
                  {new Date(trigger.createdAt).toLocaleDateString()}
                </Typography>
              </TableCell>
              <TableCell align="right" sx={{ whiteSpace: 'nowrap', minWidth: 112 }}>
                <Box
                  sx={{
                    display: 'inline-flex',
                    flexDirection: 'row',
                    flexWrap: 'nowrap',
                    alignItems: 'center',
                    justifyContent: 'flex-end',
                    gap: 0.25
                  }}
                >
                  <IconButton
                    size="small"
                    onClick={() => onEdit(trigger)}
                    color="primary"
                  >
                    <Edit />
                  </IconButton>
                  <IconButton
                    size="small"
                    onClick={() => onDelete(trigger._id)}
                    color="error"
                  >
                    <Delete />
                  </IconButton>
                </Box>
              </TableCell>
            </TableRow>
          ))
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default TriggerList; 